<template>
  <div class="sync-drag__container hide-mobile-action">
    <div class="sync-drag__action" @mousedown="start()"></div>
  </div>
</template>

<script>
export default {
  name: "SyncDragComponent",
  props: {
    target: { required: true }
  },
  components: {},
  data() {
    return {
      enabled: false
    };
  },
  methods: {
    start() {
      this.enabled = true;
    },
    stop() {
      this.enabled = false;
    },
    update(cursor) {
      if (!this.enabled) {
        return;
      }

      let target = this.simpleProps(this.target);
      let container = (() => {
        let el = this.target.$parent;
        let type = el.$el.getAttribute("element");
        if (type != "PanelComponent") {
          el = el.$parent;
        }
        return this.simpleProps(el);
      })();

      let toApply = [];
      let max = Number.MIN_SAFE_INTEGER;

      let children = container.children();
      for (const i in children) {
        if (!children.hasOwnProperty(i)) {
          continue;
        }
        const c = children[i];

        if (c.id == this.target.id) {
          continue
        }

        let sub = this.simpleProps(c);
        if (
          sub.x > target.x + target.width ||
          sub.x + sub.width < target.x ||
          sub.y + sub.height < target.y
        ) {
          continue;
        }

        let gap = sub.y - target.y;
        let top = cursor.clientY - container.y - target.height + gap;
        if (top < 0) {
          return;
        }
        if (top + sub.height > max) {
          max = top + sub.height;
        }

        toApply.push([sub.component, { top: `${top}px` }]);
      }

      let top = cursor.clientY - container.y - target.height;
      if (top < 0) {
        return;
      }
      toApply.push([target.component, { top: `${top}px` }]);

      if (top + target.height > max) {
        max = top + target.height;
      }

      if (container.height < max) {
        toApply.push([container.component, { height: `${max}px` }]);
      }

      this.$nextTick(() =>
        toApply.forEach(([el, config]) => {
          el.internal_config = {
            ...el.internal_config,
            ...config
          };
        })
      );
    },
    safeToNumber(obj, prop) {
      return Number(String(obj ? obj[prop] : "").replace(/\D/g, ""));
    },
    simpleProps(component) {
      let name = component.$el.getAttribute("element");

      let height = this.safeToNumber(component.internal_config, "height");
      let width = this.safeToNumber(component.internal_config, "width");

      let isAutoHeight = this.in(name, ["GroupMenuComponent", "TextComponent"]);

      let rect = component.$el.children[0].getBoundingClientRect();
      if (!height || height < 0 || isAutoHeight) {
        height = rect.height;
      }
      if (!width || width < 0) {
        width = rect.width;
      }

      let { x, y } = component.$el.getBoundingClientRect();
      return {
        component,
        height,
        width,
        x,
        y,
        children() {
          return (name == "BoxComponent"
            ? component.$children[0].$children
            : component.$children
          ).filter(c => c.$el.getAttribute("element"));
        }
      };
    },
    in(item, list) {
      for (let i = 0; i < list.length; i++) {
        if (list[i] === item) {
          return true;
        }
      }
      return false;
    }
  },
  mounted() {
    window.addEventListener("mousemove", this.update);
    window.addEventListener("mouseup", this.stop);
    window.addEventListener("mouseleave", this.stop);
  },
  destroyed() {
    window.removeEventListener("mousemove", this.update);
    window.removeEventListener("mouseup", this.stop);
    window.removeEventListener("mouseleave", this.stop);
  }
};
</script>

<style lang="sass" scoped>
$primary: #007bff
.sync-drag__container
  display: flex
  align-items: center
  position: absolute
  bottom: 0
  left: 10%
  transform: translate(-50%, 50%)
  visibility: hidden
  .sync-drag__action
    vertical-align: middle
    line-height: 16px
    text-align: center
    background-color: $primary
    height: 18px
    width: 18px
    color: #fff
    border-radius: 100%
    line-height: 17px
    box-shadow: 0 1px 3px 0 rgba(43,86,114,.43)
    cursor: pointer
    &:before
      content: "▼"
      display: inline
      font-size: 12px
.widget-focused:not([data-editing="true"]), .widget-focused:not([data-editing="true"])>.vdr
  &> .sync-drag__container, &> .rotate-target > .sync-drag__container
    visibility: visible
</style>



// WEBPACK FOOTER //
// src/components/editor/resources/SyncDrag.vue